import React from "react";
import { useNavigate } from "react-router-dom";

const BottomDiv = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white flex flex-col lg:flex-row items-center justify-between mx-auto max-w-7xl mt-16 mb-10">
      <div className="px-12 lg:px-0 mb-4 lg:mb-0">
        <h1 className="text-center lg:text-start text-2xl lg:text-3xl text-[#052035] mb-1">
          Test Your Skills, Earn
          <br />
          Your Rewards
        </h1>

        <p className="text-center lg:text-start text-sm text-[#374D5D]">
          Let us turn your knowledge and creativity into tangible rewards.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center md:space-x-4 space-y-4 md:space-y-0">
        <button className="w-full md:w-auto px-10 py-4 bg-[#3BF5CA] border text-[#052035] border-[#052035]  rounded-md">
          <a href="https://app.hallimo.com/register">Get Started</a>
        </button>
        <button
          onClick={() => navigate("/patrons")}
          className="w-full md:w-auto px-10 py-4 text-[#052035] border border-[#052035] rounded-md"
        >
          Become A Patron
        </button>
      </div>
    </div>
  );
};

export default BottomDiv;
